import Vue from "vue";

import moment from "moment";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import MesesDoAno from "@/models/enum/mesesDoAno";
import SpedService from "@/services/spedService";
import FileHelper from "@/utils/common/fileHelper";

import "../crud/crud.scss";

const service = new SpedService();

@Component({
    components: {
        fieldsetComponent,
        comboComponent,
        actionBarComponent,
    },
})
export default class SpedComponent extends Vue {
    mes = 0;
    ano: number = null;
    mesesOptions = EnumExtensions.getNamesAndValuesOrderedByValues(MesesDoAno);

    private load() {
        const dataAtual = moment(new Date());
        this.mes = dataAtual.month();
        this.ano = dataAtual.year();
    }

    private async save() {
        if (await this.$validator.validateAll()) {
            const response = await service
                .geraTXT({
                    mes: this.mes,
                    ano: this.ano,
                })
                .withLoading()
                .resolveWithResponse();

            if (response.ok) {
                const blob = await response.blob();
                const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];

                FileHelper.download(blob, fileName, "application/txt");
            }
        } else {
            this.$focusErrorField();
        }
    }

    private cancel() {
        this.$router.back();
    }

    private async mounted() {
        this.load();
    }
}
